<div class="verify">
  <h1>{{ "verify.loading" | translate }}</h1>
</div>
